<template>
  <div class="items-counter" v-if="count">
    <template v-if="suffixText">
      {{ $t(suffixText, [count]) }}
    </template>
    <template v-else>
      {{ $t(prefixText, [count]) }}
    </template>
  </div>
</template>

<script>
export default {
  name: "ItemsCounter",
  props: {
    count: {
      type: Number,
      default: () => 0
    },
    prefixText: {
      type: String,
      default: "message.common.selectedCount"
    },
    suffixText: {
      type: String
    }
  }
};
</script>

<style lang="scss" scoped>
.items-counter {
  padding-left: 2px;
  color: $grey-darker;
  opacity: 0.6;
  font-weight: 400;
  @include font-size(14px);
}
</style>
